export default {
  id: 'RegisterUserModal',
  code: 'CN',
  text: {
    'Email': '邮箱',
    'Verification Code, New Password, and Email are required': '验证码，新密码，邮箱必填',
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/RegisterUser/locale.js